<template>
	<div class="content">
		<div class="section">
			<div class="tips">
				温馨提示： 仅开取30天内消费完成订单，所开取的发票类型都皆为电子增值税普通发票，详询联系客服
			</div>
			<div class="tag flex-row">
				   <div class="flex-column">
          <img src="../../assets/img/btzs-icon.png" />
          <span>开票基础信息</span>
        </div>
			
			</div>
			<div class="baseInfo">
				<div class="nav flex-row">
					<div class="nav-item" :class="currentTab==0?'activeNav':''" @click="changeNav(0)">
						单位开票
					</div>
					<div class="nav-item" :class="currentTab==1?'activeNav':''" @click="changeNav(1)">
						个人开票
					</div>
				</div>
				<div class="Inputbox">
					<div class="info">
						<div class="item flex-row" v-if="currentTab==0">
							<span>公司名称</span>
							<!-- <el-input type="text" placeholder="请输入公司名称" v-model="name">
							</el-input> -->
							<el-autocomplete class="inline-input" v-model="name" :fetch-suggestions="querySearch"
								placeholder="请输入公司名称" @select="handleSelect" :trigger-on-focus="false">
							</el-autocomplete>
						</div>
						<div class="item flex-row" v-if="currentTab==0">
							<span>公司税号</span>
							<el-input type="text" placeholder="请输入公司税号" v-model="companyTaxNumber">
							</el-input>
						</div>
						<div class="item flex-row" v-if="currentTab==1">
							<span>个人名称</span>
							<el-input type="text" placeholder="请输入个人名称" v-model="name">
							</el-input>
						</div>
						<div class="item flex-row">
							<span>电子邮箱</span>
							<el-input type="text" placeholder="请输入电子邮箱" v-model="email">
							</el-input>
						</div>
					</div>
				</div>
			</div>
			<div class="tag flex-row">
				   <div class="flex-column">
          <img src="../../assets/img/btzs-icon.png" />
          <span>更多内容(非必填)</span>
        </div>
			</div>
			<div class="more">
				<div class="info flex-row">
					<div class="item flex-row">
						<span>公司地址</span>
						<el-input type="text" placeholder="请输入公司地址" v-model="address">
						</el-input>
					</div>
					<div class="item flex-row">
						<span>公司电话</span>
						<el-input type="text" placeholder="请输入公司电话" v-model="phone">
						</el-input>
					</div>
					<div class="item flex-row">
						<span>开&ensp;户&ensp;行</span>
						<el-input type="text" placeholder="请输入开户行名称" v-model="bank">
						</el-input>
					</div>
					<div class="item flex-row">
						<span>开户账号</span>
						<el-input type="text" placeholder="请输入开户账号" v-model="accountNumber">
						</el-input>
					</div>
					<div class="item flex-row textarea">
						<span>备&emsp;&emsp;注</span>
						<el-input type="textarea" placeholder="请输入备注内容" v-model="remark" resize="none">
						</el-input>
					</div>
				</div>
			</div>
			<div class="tag flex-row">
				  <div class="flex-column">
          <img src="../../assets/img/btzs-icon.png" />
          <span>发票信息</span>
        </div>
			
			</div>
			<div class="invoiceinfo">
				<span class="title">发票内容</span>
				<div class="table">
					<div class="item flex-row">
						<div class="name">
							开票类型
						</div>
						<span>*文化服务*门票</span>
					</div>
					<div class="item flex-row">
						<div class="name">
							开票方
						</div>
						<span>四川大学博物馆</span>
					</div>
					<div class="item flex-row">
						<div class="name">
							开票金额
						</div>
						<span>￥{{totalPrice}}</span>
					</div>
				</div>
			</div>
			<div class="btnbox flex-row">
				<div class="backbtn cursorp" @click="toPage">
					返回
				</div>
				<div class="confirmbtn cursorp" @click="SaveInvoiceOrder" v-if="id==''">
					确认提交
				</div>
				<div class="confirmbtn cursorp" @click="resetOpenInvoice" v-if="id!=''">
					确认提交
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		SaveInvoiceOrder,
		merchantNo,
		resetOpenInvoice,
		getCompanyName,
		getCompanyCode
	} from '@/utils/http.js'
	export default {
		name: 'InvoiceInfo',
		data() {
			return {
				currentTab: 0,
				companyTaxNumber: '',
				name: '',
				email: '',
				address: '',
				phone: '',
				bank: '',
				accountNumber: '',
				remark: '',
				param: {},
				orderSn: '',
				totalPrice: 0,
				id: '',
				restaurants: [],
			}
		},
		mounted() {
			// 获取上一页传递过来的参数
			let params = this.$route.params
			this.orderSn = params.orderNo.join(',')
			this.totalPrice = params.totalPrice
			this.id = params.id != undefined ? params.id : '' //id不为空表示点击的是重开
		},
		methods: {
			// 申请重开提交发票信息
			resetOpenInvoice() {
				if (this.currentTab == 0 && this.name == '') {
					this.$message({
						message: '请填写公司名称！',
						type: 'error',
						offset: '400'
					});
					return
				}
				if (this.currentTab == 1 && this.name == '') {
					this.$message({
						message: '请填写个人名称！',
						type: 'error',
						offset: '400'
					});
					return
				}
				if (this.currentTab == 0 && this.companyTaxNumber == '') {
					this.$message({
						message: '请填写公司税号！',
						type: 'error',
						offset: '400'
					});
					return
				}
				if (this.email == '') {
					this.$message({
						message: '请填写接收邮箱！',
						type: 'error',
						offset: '400'
					});
					return
				}
				let params = {
					invoiceClassify: this.currentTab, //开票类型、0公司，1个人
					invoiceHeader: this.name, //发票抬头
					invoiceType: 0, //发票类型（0普通电子发票）
					companyTaxNumber: this.companyTaxNumber, //公司税号
					bankAccount: this.accountNumber, //开户行账号
					companyAddress: this.address, //公司地址
					concatNumber: this.phone, //公司电话
					bankName: this.bank, //公司开户行
					email: this.email, //接收邮箱
					invoiceContent: this.remark, //备注内容
					id: this.id, //重开数据的id
					sourceType: "2", //官网
				}
				resetOpenInvoice(params).then((res) => {
					// 返回上一页
					this.$router.go(-1)
				})
			},
			// 提交开票信息
			SaveInvoiceOrder() {
				if (this.currentTab == 0 && this.name == '') {
					this.$message({
						message: '请填写公司名称！',
						type: 'error',
						offset: '400'
					});
					return
				}
				if (this.currentTab == 1 && this.name == '') {
					this.$message({
						message: '请填写个人名称！',
						type: 'error',
						offset: '400'
					});
					return
				}
				if (this.currentTab == 0 && this.companyTaxNumber == '') {
					this.$message({
						message: '请填写公司税号！',
						type: 'error',
						offset: '400'
					});
					return
				}
				if (this.email == '') {
					this.$message({
						message: '请填写接收邮箱！',
						type: 'error',
						offset: '400'
					});
					return
				}
				let params = {
					invoiceClassify: this.currentTab, //开票类型、0公司，1个人
					invoiceHeader: this.name, //发票抬头
					invoiceType: 0, //发票类型（0普通电子发票）
					orderSn: this.orderSn, //开票订单号
					companyTaxNumber: this.companyTaxNumber, //公司税号
					bankAccount: this.accountNumber, //开户行账号
					companyAddress: this.address, //公司地址
					concatNumber: this.phone, //公司电话
					bankName: this.bank, //公司开户行
					email: this.email, //接收邮箱
					invoiceContent: this.remark, //备注内容
					sourceType: 2, //官网
				}
				SaveInvoiceOrder(params).then((res) => {
					// 返回上一页
					this.$router.go(-1)
				})
			},
			// 返回上一页
			toPage() {
				this.$router.back()
			},
			changeNav(val) {
				this.currentTab = val
			},
			// 模糊查询公司名称
			querySearch(queryString, cb) {
				// 输入数量大于三时开始查询
				if (queryString.length > 3) {
					let params = {
						name: queryString
					}
					getCompanyName(params).then((res) => {
						var results = res.data;
						let list = []
						for (let li of results) {
							list.push({
								value: li.name,
								code: li.code
							})
						}
						// 调用 callback 返回建议列表的数据
						cb(list);
					})
				}

			},
			// 获取公司税号
			getCompanyCode(params) {
				getCompanyCode(params).then((res) => {
					this.companyTaxNumber = res.data.kpCode
				})
			},
			// 选择输入建议
			handleSelect(item) {
				this.getCompanyCode({
					code: item.code
				})
			}
		},
	}
</script>

<style scoped>
	.content {
		width: 1200px;
		background:#fff;
		background-size: 100% 100%;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
		margin: auto;
		padding: 24px;
		box-sizing: border-box;
	}

	.section .tips {
		width: 1152px;
		height: 48px;
	background: #f5f5f5;
		margin: auto;
		line-height: 48px;
		padding-left: 14px;
		box-sizing: border-box;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #BA2A17;
		margin-bottom: 10px;
	}

	.baseInfo {
		padding: 0 60px;
		box-sizing: border-box;
	}

	.baseInfo .nav-item {
		padding: 0 36px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 6px;
		border: 1px solid #999999;
		box-sizing: border-box;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #999999;
		margin-right: 18px;
		line-height: 40px;
		margin-bottom: 24px;
	}

	/* nav激活样式 */
	.activeNav {
		background: #BB2916 !important;
		border: none !important;
		color: #fff !important;
	}

	.Inputbox {
		justify-content: space-between;
	}

	.Inputbox span:before {
		content: '*';
		color: #AF0B0B;
	}

	.info .item {
		margin-bottom: 16px;
	}

	.info .item span {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #333;
		margin-right: 14px;
	}

	.more {
		width: 1008px;
		margin-left: 60px;
	}

	.more .info {
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.invoiceinfo {
		width: 1008px;
		margin-left: 60px;
		margin-bottom: 24px;
		display: flex;
		flex-direction: row;
	}

	.invoiceinfo .title {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		margin-right: 15px;
		margin-top: 10px;
		display: block;
	}

	.invoiceinfo .table {
		width: 921px;
		background: #FFFFFF;
		border: 1px solid #C2C2C2;
	}

	.table .item {
		height: 40px;
		width: 100%;
		border-bottom: 1px solid #C2C2C2;
	}

	.table .item:last-child {
		border-bottom: none;
	}

	.table .item .name {
		width: 192px;
		height: 100%;
		background: #FAFAFA;
		line-height: 40px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.table .item span {
		display: block;
		width: 728px;
		height: 100%;
		padding: 0 16px;
		box-sizing: border-box;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #BB2916;
		line-height: 40px;
	}

	.btnbox {
		justify-content: center;
		margin-top: 24px;
	}

	.backbtn {
		width: 324px;
		height: 60px;
		background: #ffffff;
		border-radius: 30px;
		line-height: 60px;
		text-align: center;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #BA2A17;
		border: 1px solid #BA2A17;
		margin-right: 32px;
	}

	.confirmbtn {
		width: 324px;
		height: 60px;
		background: #BA2A17;
		border-radius: 30px;
		line-height: 60px;
		text-align: center;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	/deep/ .baseInfo .item .el-input {
		width: 920px;
		height: 40px;
	}

	/deep/ .baseInfo .item .el-input__inner {
		width: 920px;
		height: 40px;
		background: #FAFAFA;
		border: 1px solid #E9E9E9;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	/deep/ .more .item .el-input {
		width: 412px;
		height: 40px;
	}

	/deep/ .more .item .el-input__inner {
		width: 412px;
		height: 40px;
		background: #FAFAFA;
		border: 1px solid #E9E9E9;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	/deep/ .more .textarea .el-textarea {
		width: 920px;
		height: 188px;
	}

	/deep/ .more .textarea .el-textarea__inner {
		width: 920px;
		height: 188px;
		background: #FAFAFA;
		border: 1px solid #E9E9E9;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}
</style>
